import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=d28ceaba&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d28ceaba')) {
      api.createRecord('d28ceaba', component.options)
    } else {
      api.reload('d28ceaba', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=d28ceaba&", function () {
      api.rerender('d28ceaba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wa3ZxpxukFMC/JS/comp/openstreetmap.vue"
export default component.exports